export const iconFieldLaraThemeConfig = {
  css: ({ dt }: any) => `
    .p-iconfield.small .p-inputicon:first-child {
      inset-inline-start: ${dt("formField.sm.paddingX")};
    }
    .p-iconfield.small .p-inputicon.right {
      & {
        inset-inline-end: calc(${dt("formField.sm.paddingX")} + var(--right-icon-size) + 5px);
      }
      &:last-child {
        inset-inline-end: ${dt("formField.sm.paddingX")};
      }
    }
    .p-iconfield:has(.p-inputfield-sm) .p-inputicon {
      z-index: 1;
      width: auto;
      height: auto;
      margin-top: auto;
      transform: translateY(-50%)
    }
    .p-iconfield.small .p-inputtext:not(:first-child),
    .p-iconfield.small .p-select-sm:not(:first-child) .p-select-label,
    .p-iconfield.small .p-multiselect-sm:not(:first-child) .p-multiselect-label {
      padding-inline-start: calc((${dt("formField.sm.paddingX")} * 2) + var(--left-icon-size));
    }
    .p-iconfield .p-inputwrapper:not(:last-child) .p-inputtext-sm,
    .p-iconfield.small .p-select-sm:not(:last-child) .p-select-label,
    .p-iconfield.small .p-multiselect-sm:not(:last-child) .p-multiselect-label {
      padding-inline-end: calc((${dt("formField.sm.paddingX")} * 2) + var(--right-icon-size));
    }
  `,
};
